import { createColorPalette } from '@ourbranch/ui-core';
const brand = {
    constants: {
        SHORT_NAME: 'Forreston',
        FULL_NAME: 'Forreston Mutual Insurance',
        LEGAL_NAME: 'Forreston Mutual Insurance Company',
        EMAIL_SENDER: 'Forreston Mutual',
        EMAIL_BCC: 'info@forrestonmutual.com',
        SUPPORT_NAME: 'Forreston Mutual',
        DOMAIN: 'forrestonmutual.com',
        SUPPORT_EMAIL: 'info@forrestonmutual.com',
        DISPLAY_NAME: 'Forreston',
        MARKETING_NAME: 'Forreston Mutual Insurance',
        POLICY_ISSUER: 'Forreston Mutual Insurance Company',
        CLAIMS_HANDLER: 'Forreston',
        REFERRAL_NAME: 'Forreston Mutual',
        SOCIAL_HANDLE: 'Forreston',
        PAYMENT_ADDRESS: 'Forreston Mutual Insurance Company PO Box 15674 Worcester, MA 01615',
        EXPEDITED_PAYMENT_ADDRESS: 'Forreston Mutual Insurance Company 370 Main Street, Ste 880 Worcester, MA 01608',
        CUSTOMER_SERVICE_PHONE: '800-938-2270',
        CUSTOMER_SERVICE_PHONE_LETTERS: '800-938-2270',
        SUPPORT_RENEWAL_AND_CANCEL_QUESTIONS_PHONE: '800-938-2270',
        CLAIMS_PHONE: '800-938-2270',
        // TODO: update once forreston has set up a claims email
        CLAIMS_EMAIL: '#',
        // #36703: the insured portal's "File a claim" modal links members to the Forreston FNOL form (same page the
        // Staff help speed dial uses, #35911).
        CLAIMS_FNOL_URL: 'https://forreston.ember.liberate.claims/fnol',
        AGENCY_SUPPORT_EMAIL: 'this-is@a.placeholder',
        AGENCY_SUPPORT_PHONE: '(800) 938-2270',
        AGENCY_SUPPORT_HOURS: 'Mon-Fri, 8am-4pm Central',
        MEMBER_COMMS_EMAIL: 'this-is@a.placeholder',
        SMS_SHORTCODE: '',
        PRIVACY_POLICY_URL: 'https://www.forrestonmutual.com/privacy-policy/',
        // TODO: Get terms of use URL for Forreston
        TERMS_OF_USE_URL: '#',
        // TODO: Get communications consent URL for Forreston
        COMMUNICATIONS_CONSENT_URL: '#',
        IOS_APP_STORE_URL: '#',
        ANDROID_GOOGLE_PLAY_STORE_URL: '#',
        // Blank: the credit-card fee note is inaccurate for this mutual (#33401).
        SMALL_BILLING_NOTE: ''
    },
    theme: {
        palette: createColorPalette({
            primaryMain: '#A6192E',
            backgroundsMain: '#F0F0F0',
            typographyMain: '#3A3A3A',
            controlsMain: '#D4D0CD',
            errorMain: '#7A0027'
        }),
        loaderColor: '#BB6058',
        showLogoInLoader: false,
        showAccountBackgroundHero: false,
        logoWidthDesktop: 320,
        logoWidthMobile: 230
    },
    config: {
        supportedStates: ['IL'],
        // #34376: supplemental documents an underwriter can attach from the Policy Settings page. Keep in
        // sync with brand-config-be's forreston catalog (the backend resolves these ids to S3 keys). The
        // Branch (Subscriber) Agreement is only offered on migrated-renewal policies.
        supplementalDocuments: [
            {
                id: 'wood-heat-questionnaire',
                label: 'Wood Heat Questionnaire',
                s3Key: 'supplemental-documents/wood-heat-questionnaire.pdf'
            },
            {
                id: 'blanket-inventory-list',
                label: 'Blanket Inventory List',
                s3Key: 'supplemental-documents/farm-blanket-inventory.pdf'
            },
            {
                id: 'branch-agreement',
                label: 'Branch Agreement',
                s3Key: 'supplemental-documents/subscriber-agreement.pdf',
                migratedRenewalsOnly: true
            },
            // #35891: Forreston's Recurring Payment Authorization form (farm-based policies only).
            {
                id: 'recurring-payment-authorization',
                label: 'Recurring Payment Authorization Form',
                s3Key: 'supplemental-documents/recurring-payment-authorization.pdf'
            }
        ],
        supportedFees: {
            creditCard: true
        },
        // Hold rateControlDate up to 5 days by default, 60 for underwriters (issue #32130).
        rateControlDate: { maxStaleDaysToBind: 5, underwriterMaxHoldDays: 60 },
        // Mutual: 15-day billing-hold cap, reason required, "hold cancellations as well" option available (#33568).
        billingHold: { maxDays: 15, requireReason: true, holdCancellationsEnabled: true }
    }
};
export const constants = brand.constants;
export const theme = brand.theme;
export default brand.config;
